import React from 'react'
import LocationInput from 'sprockets_react/components/LocationInput'

const LightboxLocation = React.createClass({
  getInitialState: function getInitialState() {
    return {
      suburb: this.props.suburb || '',
      suburbId: this.props.suburbId || '0',
      inputClass: this.props.inputClass || '',
      formName: this.props.formName || '.business-directory-form'
    };
  },

  componentDidMount: function componentDidMount() {
    this.setupValidation();
  },

  setupValidation: function setupValidation() {
    $(this.state.formName).bootstrapValidator({
      fields: {
        location: {
          excluded: false,
          validators: {
            callback: {
              message: 'Enter a postcode or suburb and select from the list below',
              callback: function(value, validator, $field) {
                let result = ($field.val().length > 0 && $field.attr('data-suburb-id') !== '0')
                return { valid: result }
              }
            }
          }
        }
      }
    });
  },

  handleAutocompleteSelection: function handleAutocompleteSelection(event, response) {
    this.setState({ suburbId: response.item.id });
    $(event.target).data('suburb-id', response.item.id);
    $(this.state.formName).data('bootstrapValidator').revalidateField('location');
  },

  handleLocationChange: function handleLocationChange(event) {
    let value = event.currentTarget.value
    this.setState({ suburbId: '', suburb: value });
    $(event.currentTarget).data('suburb-id', '0');
    $(this.state.formName).data('bootstrapValidator').updateStatus($(event.currentTarget).attr('name'), 'NOT_VALIDATED');
  },

  render: function render() {
    return (
      <div className="home-text-area">
        <div className="form-group">
          <LocationInput
            suburb={this.state.suburb}
            suburbId={this.state.suburbId}
            handleAutocompleteSelection={this.handleAutocompleteSelection}
            handleLocationChange={this.handleLocationChange}
            guId={SS.utils.generateGuid()}
            inputClass={this.state.inputClass}
          />
        </div>
        <div className="form-group">
          <input type="hidden"
            name="suburb_id"
            value={this.state.suburbId}
          />
        </div>
      </div>
    )
  }
});

export default LightboxLocation
